import { ReactNode } from "react";
import { RiExternalLinkLine } from "@remixicon/react";

interface ResourceLinkProps {
  title: string;
  icon: ReactNode;
  link: string;
  disabled?: boolean;
  note?: string;
}

export function ResourceLink({ title, icon, link, disabled, note }: ResourceLinkProps) {
  if (disabled) {
    return (
      <div className="flex items-center p-4 rounded-lg border border-border bg-sidebar/50 opacity-70">
        <div className="w-10 h-10 rounded-full bg-muted flex items-center justify-center mr-3">
          <div className="text-muted-foreground">{icon}</div>
        </div>
        <div className="flex-1">
          <div className="flex items-center justify-between">
            <h3 className="text-base font-medium">{title}</h3>
            {note && <span className="text-xs text-muted-foreground">{note}</span>}
          </div>
        </div>
      </div>
    );
  }

  return (
    <a
      href={link}
      target="_blank"
      rel="noopener noreferrer"
      className="group"
    >
      <div className="flex items-center p-4 rounded-lg border border-border bg-sidebar hover:border-[#FF8A3C]/50 transition-all duration-300">
        <div className="w-10 h-10 rounded-full bg-muted flex items-center justify-center mr-3 group-hover:bg-[#FF8A3C]/10 transition-colors">
          <div className="text-muted-foreground group-hover:text-[#FF8A3C] transition-colors">{icon}</div>
        </div>
        <div className="flex-1">
          <div className="flex items-center justify-between">
            <h3 className="text-base font-medium group-hover:text-[#FF8A3C] transition-colors">{title}</h3>
            <RiExternalLinkLine className="size-4 text-muted-foreground group-hover:text-[#FF8A3C] transition-colors" />
          </div>
        </div>
      </div>
    </a>
  );
}
